<template>
    <div v-loading="loading">
        <div class="text-center full-width mb-4">
        <span class="ty-border-bottom bw-2 text-center pb-2 ty-border-color-primary px-3 fw-500 fs-16">ایجاد
            فاکتور فروش </span>
        </div>
        <div class="invoice-editor-content">
            <basic-form v-if="invoice" :invoice="invoice" />
            <shipping-form v-if="invoice" :invoice="invoice" />
            <payment-form v-if="invoice" :invoice="invoice" />
            <div class="text-left py-4">
                <ty-button color="success" @click="publish">ایجاد فاکتور</ty-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        Instance
    } from '@/classes/TayehApi';
    import {
        InvoiceTypeName
    } from '../assets/InvoiceTypeName';
    export default {
        name: 'TyInvoiceEditor',
        inject: ['getInstance'],
        props: {
            invoice: {
                type: [Object],
                required: true
            },
        },
        data() {
            const {
                getInstance
            } = this;
            const instance_id = getInstance().id;
            return {
                instance_id: instance_id,
                // invoice: null,
                loading: false,
                iframe_key: 0,

            }
        },
        methods: {
            async getInvoice() {
                this.loading = true;
                this.invoice = (await Instance.getInstanceInvoice(this.instance_id, this.invoiceId)).data;
                this.loading = false;
            },
            async publish() {
				this.loading = true;
				try {
					this.invoice.invoice_number = await Instance.publishInstanceSoldInvoice(this.instance_id, this.invoice)
					this.$message({
						showClose: true,
						message: 'فاکتور با موفقیت ویرایش شد.',
						type: 'success',
						duration: 5000
					});
				} catch (err) {
					this.$message({
						showClose: true,
						message: 'فاکتور ذخیره نشد، لطفا دوباره تلاش کنید.',
						type: 'error',
						duration: 5000
					});
				} finally {
                    this.loading = false;
                }
					// this.iframe_key++;
			},
        },
        components: {
            'basic-form': () => import(`./InvoiceEditor/sold/BasicForm`),
            'shipping-form': () => import(`./InvoiceEditor/sold/ShippingForm`),
            'payment-form': () => import(`./InvoiceEditor/sold/PaymentForm`)
        },
        computed: {
            typeName() {
                return InvoiceTypeName[this.invoice?.type]?.name??'نامشخص';
            }
        },
        // created() {
        //     this.getInvoice()
        // }
    }
</script>
<style scoped>
.invoice-editor-content {
    max-height: 100%;
}
</style>